export default {
  supplyDocumentList: {
    method: 'post',
    url: '/supply/document/list'
  },
  supplyDocumentListById: {
    method: 'post',
    url: '/supply/document/list/ID'
  },
  supplyDocumentCreate: {
    method: 'post',
    url: '/supply/document'
  },
  supplyDocumentUpdate: {
    method: 'put',
    url: '/supply/document'
  },
  supplyDocumentDelete: {
    method: 'delete',
    url: '/supply/document'
  }
}
